import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { checkWin } from "@alife/cone-arms-core";
import { init as initCnFilterEnhance } from "./cn-fliter-enhance";
// 一个页面只能有一个插件
var hasInit = false;
var defaultConfig = {
    injectCnFilter: true
};
var TraceCNUIEnhancePlugin = function(core) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!checkWin() || hasInit) {
        return;
    }
    var finalConfig = _object_spread({}, defaultConfig, config);
    hasInit = true;
    if (finalConfig.injectCnFilter) {
        initCnFilterEnhance(core);
    }
};
TraceCNUIEnhancePlugin.pluginName = "CNUIEnhance";
export default TraceCNUIEnhancePlugin;

 //# sourceMappingURL=index.js.map